module.exports = __webpack_public_path__ + "bf96506f468d52bbfbccbdf424ed430f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/logo-color.svg
// module id = 3
// module chunks = 0 1 2